var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcSearchBl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 49"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.74121 13.5425C10.0549 13.5425 12.7412 10.8562 12.7412 7.54248C12.7412 4.22877 10.0549 1.54248 6.74121 1.54248C3.4275 1.54248 0.741211 4.22877 0.741211 7.54248C0.741211 10.8562 3.4275 13.5425 6.74121 13.5425Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.2583 18.4575L11.2583 12.4575",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSearchBl);
export default __webpack_public_path__ + "static/media/ic_search_bl.053b6cb2f8f54ac6a0b4792e714ffa44.svg";
export { ForwardRef as ReactComponent };